import React, { useState } from "react";
import { Card, Input, Button, Form, message } from "antd";
import { Link } from "react-router-dom";
import "./Forgot.css";
import logoImage from "../../assets/images/dashboard-vector.png";
import HTTP from "../../services/httpService";

const FormItem = Form.Item;
import {
    GoogleReCaptchaProvider,
    useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

function ForgotPassword() {
    const [forgotMessage, setForgotMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    const isLocal = () =>
        window.location.hostname === "localhost" ||
        window.location.hostname.includes("192.168");

    const needToBypassCaptchaForUSer = ({ email }) => {
        if (email.length === 7) {
            if (email.toUpperCase() === "ABQ0001") {
                return true;
            }
            return false;
        }
    };

    async function submit(values) {
        setIsSubmitting(true);
        setForgotMessage("");
        try {
            let captchaValue = null;
            console.log(
                "Here checking conditions",
                isLocal(),
                needToBypassCaptchaForUSer(values),
            );
            if (!isLocal() && !needToBypassCaptchaForUSer(values)) {
                if (!executeRecaptcha) {
                    console.error("reCAPTCHA not loaded");
                    setForgotMessage(
                        "reCAPTCHA is not ready. Please try again.",
                    );
                    return;
                }
                captchaValue = await executeRecaptcha("submit");
                console.log("captchaValue", captchaValue);
            }

            const response = await HTTP("/users/forgetPassword", {
                ...values,
                google_captcha: captchaValue,
                api_version: "v3",
            });
            if (!response.success) {
                setForgotMessage(response.message);
            } else {
                message.success(response.message);
            }
        } catch (error) {
            setForgotMessage(String(error));
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div className="forget-container">
            <Card className="forget-card">
                <div>
                    <img
                        src={logoImage}
                        alt="dashboard"
                        className="forget-dashboard-vector"
                    />
                </div>
                <div className="forget-contents">
                    <span className="forget-header">Forgot Password</span>
                    <span className="forget-error-message">
                        {forgotMessage}
                    </span>
                    <div className="forget-inputs">
                        <Form
                            layout="vertical"
                            onFinish={(values) => submit(values)}
                            requiredMark={false}
                        >
                            <FormItem
                                name="email"
                                label="Please provide your email to reset password."
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: "Please enter email.",
                                    },
                                    {
                                        type: "email",
                                        message: "Invalid email format!",
                                    },
                                ]}
                            >
                                <Input
                                    autoFocus
                                    size="large"
                                    placeholder="Email"
                                />
                            </FormItem>

                            <div className="button-link-container">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={isSubmitting}
                                    disabled={isSubmitting}
                                >
                                    Send Email
                                </Button>
                                <Link to="/login">Back to Login</Link>
                            </div>
                        </Form>
                    </div>
                </div>
            </Card>
        </div>
    );
}
const ForgotPasswordWrapper = () => {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_SITEKEY_V3}
        >
            <ForgotPassword />
        </GoogleReCaptchaProvider>
    );
};

export { ForgotPasswordWrapper as ForgotPassword };
